import bidello,{component} from "bidello";
import {AbstractUI} from "./AbstractUI";
import {States} from "../services/StateManager";

export class ViewNavigation extends component(AbstractUI) {

    init(){

        this.views = this.domElement.querySelectorAll(".view");
        this.stateHistory = [];
        this.currentView = null;
        this.previousView = null;
        this.nextState(0);
    }

    show (){

        this.domElement.style.display = "block"

    }

    hide (){

        this.domElement.style.display = "none"

    }

    onStateChange (state){

        if (state.state == States.viewNavigation.NEXT_STATE)this.nextState(state.info)
        if (state.state == States.viewNavigation.BACK_STATE)this.backState();

    }

    nextState(childViewId){

        const selectedItem = this.domElement.querySelector(`.state-change-trigger[data-info='${childViewId}']`);
        const nextState = this.domElement.querySelector(`.view[data-parent='${childViewId}']`);
        if (!nextState) return;
        if (selectedItem){

            const selectedItemTitle = selectedItem.querySelector(`.item_title`);
            nextState.querySelector('.view-title').textContent = selectedItemTitle.textContent;
            nextState.querySelector('.back-button-label').textContent = selectedItemTitle.textContent

        }

        const currentState = this.stateHistory[this.stateHistory.length-1]
        if (currentState){

            currentState.classList.remove('current');
            currentState.classList.add('after');
            console.log(selectedItem,selectedItem.getAttribute('data-return-state'))

            nextState.querySelector(".back-button").setAttribute('data-state',selectedItem.getAttribute('data-return-state'));

        }
        nextState.classList.remove('before');
        nextState.classList.add('current');
        this.stateHistory.push(nextState);

       /* const selectetdItem = this.domElement.querySelector(`.state-change-trigger[data-info='${childViewId}'] .item_title`);
        const nextView = this.domElement.querySelector(`.view[data-parent='${childViewId}']`);
        if (!nextView) return;
        this.previousView = this.currentView;
        if (selectetdItem)nextView.querySelector('.view-title').textContent = selectetdItem.textContent;
        if (this.currentView){

            this.currentView.classList.remove('current');
            this.currentView.classList.add('after');
            nextView.querySelector('.back-button-label').textContent = this.currentView.querySelector('.view-title').textContent
            
        }

        nextView.classList.remove('before');
        nextView.classList.add('current');
        this.currentView = nextView;*/

    }

    backState(){

        if (this.stateHistory.length==1)return;
        const currentState = this.stateHistory.pop();
        const previousState = this.stateHistory[this.stateHistory.length-1]
        if (!currentState) return;
        currentState.classList.remove('current');
        currentState.classList.add('before');

        previousState.classList.add('current');
        previousState.classList.remove('after');



    }



}